<template>
  <div class="hello">
    <!-- <div class="top">
      <img src="@/assets/gs-banner.jpg" alt="顶部广告" class="top-img">
    </div> -->
    <Header></Header>

    <div class="content_s clearfix">
      <el-row>
        <el-col>
          <div class="last-mag clearfix">
            <div class="mag-l">

              <div class="act-list" v-for="(vl,key) in preData[1]" :key="key" v-if=" key >0 && key < 4">
                <h2>
                  {{vl.column_name}}<i class="el-icon-caret-right"></i>
                </h2>
                <h3>{{vl.title.replace(/【.*?】/,"")}}</h3>
                <p>{{ preData[2][key][0]}}</p>
              </div>

            </div>
            <div class="mag-m">
              <img :src="'http://iceo-magazine.oss-cn-qingdao.aliyuncs.com'+preData[0].cover"  alt="封面">
            </div>
            <div class="mag-r">
              <div class="act-list">
                <h1>
                  {{preData[1][0].column_name}}<i class="el-icon-caret-right"></i>
                </h1>
                <h3> {{preData[1][0].title.replace(/【.*?】/,"")}}</h3>
                <p> {{ preData[2][0][0]}}</p>

                <button type="button"  @click="redirect_buy"   class="el-button el-button--default"><!----><!----><span>订阅杂志</span></button>
              </div>
            </div>

            <div class="mag-float"><img src="@/assets/images/mag-float.png" alt="封面"></div>
          </div>

        </el-col>
      </el-row>
      <el-row>
        <el-col>
          <div class="mag-list">
            <div class="time-title">
              <h2>中企杂志</h2>
              <div class="year-list">
                <!-- 中企杂志年份 -->
                <el-tabs v-model="activeName" @tab-click="handleClick">
                  <el-tab-pane v-for="(au,index) in TatolData[0]" :key="index" :label="au.year+'年'" :name="'na_'+au.year"></el-tab-pane>
                </el-tabs>
              </div>
            </div>
            <div class="item-mag">
              <el-row>
                <!-- 杂志列表  -->
                <el-col :span="4" v-for="(o, index) in TatolData[1]" :key="index">
                  <el-card :body-style="{ padding: '15px'}"  @click.native = "redirect_todetail(o._uniquecode)">
                    <div class="_height_relative">
                      <img :src="'http://iceo-magazine.oss-cn-qingdao.aliyuncs.com'+o.cover"  class="image"></img>
                    </div>
                    
                    <div style="padding: 0px;cursor:pointer ;">
                      <h3>{{o.title}}</h3>
                      <span>{{o.date}}</span>
                    </div>
                  </el-card>
                </el-col>

              </el-row>
            </div>
          </div>
        </el-col>
      </el-row>
      <el-row>
        <el-col>
          <div class="mag-list">
            <div class="time-title">
              <h2>花卉报</h2>

            </div>
            <div class="item-mag">
              <el-row>
                <el-col :span="4">
                  <el-card :body-style="{ padding: '15px'}">
                    <img src="@/assets/images/fm2.jpg" class="image">
                    <div style="padding: 0px;">
                      <h3>《中国花卉报》订阅 </h3>
                      <span>每周四出报</span>
                    </div>
                  </el-card>
                </el-col>
              </el-row>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>

    <bbottom></bbottom>

  </div>

</template>

<script>

  import Header from "@/components/public/Header.vue"
  import bbottom from "@/components/public/bbottom.vue"
  // import vueConfig from "../../vue.config"
  export default {
    name: 'Mag',

    data() {
      return {
        activeName: 'first',
        // 小栏目频道
        preData:[],
        TatolData: [],
        
      }
    },

    props: {},
    created(){
      this.getmagazineData()
      this.getpremagazine()
    },

    //页面初始化
    computed: {

    },

    //页面加载后执行方法

    methods: {
      // 跳转文章列表页面
      redirect_todetail(unique_id){

          // this.$router.push('/maglist/detail/'+unique_id)
        let routeData = this.$router.resolve('/maglist/detail/'+unique_id)
        window.open(routeData.href, '_blank');
          
      },
      // 购买杂志页面
      redirect_buy(){
        let url = 'https://shop44045983.m.youzan.com/wscshop/feature/goods/all?kdt_id=43853815'
        window.open(url, '_blank')
      },

      // 获取最新页面的信息
      getpremagazine(){
        var config = {
          method: 'GET',
          url: '/api/v1/magazine/preartical',
          headers: { 
            'Content-Type': 'application/json'
          }
        };
            
        this.$axios(config).then(res=>{

          this.$data.preData = res.data
          console.log('请求成功')
          
        }).catch(error=>{
          console.log('请求失败')
        })
      },
      
      getmagazineData()
      {
        let yy = new Date().getFullYear();
        yy=2025
        var config = {
          method: 'GET',
          url: '/api/v1/magazine/list/'+yy,
          headers: { 
              'Content-Type': 'application/json'
          }
        };
            
        this.$axios(config).then(res=>{

          this.$data.TatolData = res.data
          console.log('请求成功')
          
        }).catch(error=>{
          console.log('请求失败')
        })
      },
      handleClick(tab, event){

        var year = tab.name.split('_')
        var config = {
          method: 'GET',
          url: '/api/v1/magazine/list/'+year[1],
          headers: { 
              'Content-Type': 'application/json'
          }
        };
            
        this.$axios(config).then(res=>{

          this.$data.TatolData = res.data
          console.log('请求成功')
          
        }).catch(error=>{
          console.log('请求失败')
        })



        





      }

    },
    //组件引入
    components: {

      Header,
      bbottom
    },
  }

</script>

<style scoped>
._height_relative{
    height:213px;
    overflow:hidden;
}
.el-button--default:focus,.el-button--default:hover {
 background-color: #bd0c16;
 color:#fff
}
  .clearfix:before,
  .clearfix:after {
    display: table;
    content: "";
  }

  .clearfix:after {
    clear: both
  }

  .content_s {
    width: 1200px;
    margin: 25px auto;
    color: #4b4b4b;
  }

  .img_s {
    width: 100%;
    border-radius: 6px;
  }

  .top {
    width: 1200px;
    margin: 0 auto;
  }

    .top img {
      display: block
    }

  .baomin {
    display: relative;
    width: 60%;
    height: 32px;
    border: white solid 2px;
    border-radius: 6px;
    text-align: center;
    color: white;
    position: absolute;
    top: 60%;
    left: 50%;
    margin-top: -50px;
    margin-left: -100px;
  }

  .fonts_bao {
  }

  .hello {
    color: rgb(58, 2, 2);
  }

  .time {
    font-size: 13px;
    color: #999;
  }

  .bottom {
    margin-top: 13px;
    line-height: 12px;
  }

  .button {
    padding: 0;
    float: right;
  }

  .image {
    width: 100%;
    display: block;
    cursor:pointer;
  }

  .clearfix:before,
  .clearfix:after {
    display: table;
    content: "";
  }

  .clearfix:after {
    clear: both
  }

  .item h3 {
    color: #e85a50;
  }

  .icon_s {
    display: inline-block;
    width: 30px;
    height: 30px;
    background: #eea01e;
    text-align: center;
    line-height: 30px;
    border-radius: 10px;
    margin-right: 15px;
    /* color:#fa5c00; */
    color: white;
  }

  .text {
    font-size: 14px;
  }

  .item {
    padding: 18px 0;
  }

  .box-card {
    width: 100%;
    margin-bottom: 20px;
  }

  .el-row {
    margin-bottom: 0px;
  }

  .el-col {
    /* margin-right:30px; */
    border-radius: 4px;
  }

  /*最新杂志*/
  .last-mag {
    width: 1100px;
    padding: 40px 50px 0px;
    background-color: #f1f1f1;
    height: 426px;
    overflow: hidden;
  }

  .mag-l, .mag-r {
    width: 380px;
    float: left;
  }

  .act-list {
    padding-top: 0px;
    padding-bottom: 15px;
  }

    .act-list h1 {
      font-size: 30px;
      line-height: 30px;
      margin: 10px auto 25px;
    }

    .act-list h2 {
      font-size: 16px;
      line-height: 24px;
      margin: 10px auto 15px;
    }

    .act-list h3 {
      font-size: 20px;
      line-height: 22px;
      margin: 0px auto 8px;
      font-weight: normal;
    }

    .act-list p {
      font-size: 14px;
      height: 40px;
      line-height: 20px;
      margin: 0px auto;
      color: #999;
      /* padding-bottom: 15px; */
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;
    }

  .el-icon-caret-right {
    vertical-align: baseline;
  }

  .mag-r {
  }

  .mag-m {
    width: 290px;
    float: left;
    margin: 0px 25px 0px;
  }

    .mag-m img {
      width: 100%;
      display: block;
    }


  .el-icon-caret-right:before {
    color: #bd0c16 !important;
    font-size: 16px !important;
    line-height: 20px
  }

  .mag-r .act-list .el-icon-caret-right:before {
    color: #bd0c16 !important;
    font-size: 30px !important;
    line-height: 30px
  }

  .el-button--default {
    background-color: #bd0c16;
    width: 130px;
    height: 40px;
    color: #ffffff;
    font-size: 18px;
    margin-top: 30px;
  }

  .mag-list {
    width: 1200px;
    margin: 30px auto;
  }

  .el-tabs--top .el-tabs__item.is-top:nth-child(2) {
    font-size: 18px !important;
    font-weight: normal !important;
  }

  .time-title {
    width: 100%;
    height: 50px;
    border: 1px solid #f1f1f1;
    border-left-width: 0px;
    border-right-width: 0px;
  }

    .time-title h2 {
      width: 120px;
      background-color: #bd0c16;
      font-size: 22px;
      color: #fff;
      display: inline-block;
      float: left;
      margin: 0px;
      line-height: 50px;
      text-align: center;
      font-weight: normal;
      height: 50px;
    }

  .year-list {
    width: 1020px;
    display: inline-block;
    margin: 0px 30px;
    float: left;
  }

  .item-mag {
    margin: 25px auto;
  }

    .item-mag .el-card {
      border: none;
      box-shadow: none;
    }

  .el-card {
    color: #4b4b4b !important;
  }

    .el-card h3 {
      margin: 0px;
      padding: 8px 2px 3px;
      font-size: 16px;
      line-height: 24px;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;
      height: 20px;
    }

    .el-card span {
      font-size: 14px;
      color: #999;
    }

    .last-mag {
    width: 1100px;
    padding: 40px 50px 0px;
    background-color: #f1f1f1;
    height: 426px;
    overflow: hidden;
    position:relative;
  }
  .mag-float{
      position:absolute;
      right:0px;
      top:0px;
      width:109px;
      height:109px;
  }
</style>



// WEBPACK FOOTER //
// src/components/magazine.vue